export const SortOrder = {
    Ascending: "asc",
    Descending: "desc",
};
/**
 * Generic sorting function for arrays of objects
 * Handles string, number, boolean, and array length sorting
 * @param items - Array to sort
 * @param key - Property key to sort by
 * @param order - Sort order (ascending or descending)
 */
export const sortBy = (items, key, order = SortOrder.Ascending) => {
    const itemsCopy = [...items];
    return itemsCopy.sort((a, b) => {
        const aValue = a[key];
        const bValue = b[key];
        if (aValue == null && bValue == null)
            return 0;
        if (aValue == null)
            return 1;
        if (bValue == null)
            return -1;
        if (typeof aValue === "string" && typeof bValue === "string") {
            const comparison = aValue.localeCompare(bValue);
            return order === SortOrder.Ascending ? comparison : -comparison;
        }
        if (typeof aValue === "number" && typeof bValue === "number") {
            return order === SortOrder.Ascending ? aValue - bValue : bValue - aValue;
        }
        if (typeof aValue === "boolean" && typeof bValue === "boolean") {
            return order === SortOrder.Ascending
                ? Number(aValue) - Number(bValue)
                : Number(bValue) - Number(aValue);
        }
        if (Array.isArray(aValue) && Array.isArray(bValue)) {
            return order === SortOrder.Ascending
                ? aValue.length - bValue.length
                : bValue.length - aValue.length;
        }
        return 0;
    });
};
/**
 * Sort by nested property or custom accessor function
 * @param items - Array to sort
 * @param accessor - Function to access the property to sort by
 * @param order - Sort order (ascending or descending)
 */
export const sortByCustom = (items, accessor, order = "asc") => {
    const itemsCopy = [...items];
    return itemsCopy.sort((a, b) => {
        const aValue = accessor(a);
        const bValue = accessor(b);
        if (aValue == null && bValue == null)
            return 0;
        if (aValue == null)
            return 1;
        if (bValue == null)
            return -1;
        if (typeof aValue === "string" && typeof bValue === "string") {
            const comparison = aValue.localeCompare(bValue);
            return order === "asc" ? comparison : -comparison;
        }
        if (typeof aValue === "number" && typeof bValue === "number") {
            return order === "asc" ? aValue - bValue : bValue - aValue;
        }
        if (typeof aValue === "boolean" && typeof bValue === "boolean") {
            return order === "asc" ? Number(aValue) - Number(bValue) : Number(bValue) - Number(aValue);
        }
        return 0;
    });
};
//# sourceMappingURL=sorting.js.map